import { LogsService } from '@gtpl/shared-services/user-logs';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DepartmentsController } from './departments.controller';
import { Departments } from './departments.entity';
import { DepartmentsService } from './departments.service';
import { DepartmentsAdapter } from './dto/departments.adapter';

@Module({
  imports: [
    TypeOrmModule.forFeature([Departments]),
  ],
  controllers: [DepartmentsController],
  providers: [DepartmentsService,DepartmentsAdapter,ApplicationExceptionHandler,LogsService]
})
export class DepartmentsModule {}
